import Swiper from 'swiper/bundle';

export default class {
  constructor() {
    let that = this;

    if (document.querySelector(".ifit-training-slider-Swiper")) {
      var swiper5 = new Swiper(".ifit-training-slider-Swiper", {
        loop: true,
        spaceBetween: 40,
        slidesPerView: 1.5,
        centeredSlides: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".ifit-training-slider__slider-nav.swiper-button-next",
          prevEl: ".ifit-training-slider__slider-nav.swiper-button-prev",
        },
        pagination: {
          el: '.ifit-training-slider__swiper-pagination',
          type: 'bullets',
        },
        breakpoints: {
          575: {
            centeredSlides: false,
            slidesPerView: 2,
            spaceBetween: 40,
          },
          768: {
            centeredSlides: false,
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      });

    }
  }
}
